<template>
  <div>
    <div class="form-floating mb-3 position-relative">
      <!-- Ícone dentro do campo -->
      <img
        v-if="iconSrc"
        :src="iconSrc"
        :alt="altText"
        class="position-absolute top-50 start-0 translate-middle-y ps-3"
        width="40px"
        style="z-index: 9;"
      />

      <!-- Input de telefone -->
      <input
        :class="['form-control ps-5', { 'error-border': errors?.length > 0 }]"
        inputmode="numeric"
        :disabled="!isEditable"
        :value="modelValue"
        type="text"
        :id="inputId"
        :placeholder="placeholder"
        @input="onInput"
        required
      >

      <!-- Label flutuante -->
      <label :for="inputId" class="ps-5">{{ label }}<span v-if="required" class="text-danger">*</span></label>
    </div>

    <!-- Mensagem de erro -->
    <p v-if="errors?.length" class="text-danger error">{{ errors[0] }}</p>
  </div>
</template>

<script>
export default {
  name: 'PhoneInputWithIcon',
  props: {
    modelValue: { type: String, required: true },
    errors: { type: Array, default: () => [] },
    isEditable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Whatsapp' },
    label: { type: String, default: 'Whatsapp' },
    inputId: { type: String, default: 'telefone_celular' },
    iconSrc: { type: String, default: 'https://img.icons8.com/?size=100&id=IrRDQlTuSTHb&format=png&color=B0B2B3' },
    altText: { type: String, default: 'Ícone de telefone' },
    required: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    formatPhone(event) {
      let value = event.target.value.replace(/\D/g, '');
      
      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (value.length > 5) {
        value = value.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
      } else if (value.length > 2) {
        value = value.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
      } else if (value.length > 0) {
        value = value.replace(/^(\d*)/, '($1');
      }

      this.$emit('update:modelValue', value);
    },
    onInput(event) {
      this.formatPhone(event);
    }
  }
}
</script>

<style scoped>
.error-border {
  border: 1px solid red !important;
  border-radius: 0.75rem !important;
}

.text-danger.error {
  width: 100%;
  text-align: left;
  padding: 5px;
  margin-bottom: 10px;
}

.form-floating input {
  padding-left: 43px !important;
}

.form-floating img {
  z-index: 9;
}

.form-control {
    height: 66px !important;
    border-radius: .75rem;
}

.form-floating.mb-3 {
  margin-bottom: 0 !important;
}
</style>
